<template>
    <div class="container">
        <div class="con_title">加工单详情</div>
        <div class="operate_row">
            <div class="">
            </div>
            <div class="status_table">
                <div class="" @click="changeStatus(1)">
                    原木加工单 dry
                </div>
                <div class="" @click="changeStatus(2)">
                    湿板(待烘干) <span>15</span>
                </div>
                <div class="" @click="changeStatus(3)">
                    干板(待检尺) <span>15</span>
                </div>
                <div class="">
                    待入库 <span>15</span>
                </div>
                <div class="">
                    已入库
                </div>
            </div>
        </div>
        <div class="table_path">
            <el-table :data="list" style="width: 100%" border height="100%" size="mini" header-cell-class-name="list_table_th">
                <el-table-column type="index"></el-table-column>
                <el-table-column type="selection"></el-table-column>
                <el-table-column label="操作"></el-table-column>
                <el-table-column label="加工日期"></el-table-column>
                <el-table-column label="加工单号"></el-table-column>
                <el-table-column label="状态"></el-table-column>
                <el-table-column label="批次号"></el-table-column>
                <el-table-column label="原木方数"></el-table-column>
                <el-table-column label="原木根数"></el-table-column>
                <el-table-column label="湿材方数"></el-table-column>
                <el-table-column label="干材方数"></el-table-column>
                <el-table-column label="加工厂"></el-table-column>
                <el-table-column label="加工费(合计)"></el-table-column>
                <el-table-column label="加工类型"></el-table-column>
                <el-table-column label="成材率"></el-table-column>
                <el-table-column label="制单人"></el-table-column>
            </el-table>
        </div>
    </div>
</template>
<style scoped lang="scss">
    .container{
        padding: 15px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2;
        .con_title{ color: #d6d6d6; }

        .operate_row{
            display: flex; align-items: center; justify-content: space-between; padding: 28px 0 8px;
            .status_table{
                display: flex; align-items: center;
                & > div{
                    color: #222222; line-height: 20px; padding: 8px 15px; border:1px solid #ABABAB; cursor: pointer;
                    & > span{ color: #FF0000; margin-left: 3px; }
                    & + div{ margin-left: -1px; }
                }
            }
        }

    }
</style>
<script>
    export default {
        props: {
            status : {
                type: [String, Number],
                default : 1
            }
        },
        components:{
        },
        data(){
            return{
                last_page: 10,
                current_page: 1,
                total: 1000,
                list : [],
                // dialog START
                dialogVisible : false,
                id : 0,
                create_form_params : {
                    params : "",
                },
                edit_form_params:{
                    params : "",
                },
                rules: {
                    company_name : [ { required: true, message: '请输入活动名称', trigger: 'blur' } ],
                },
                // dialog END
            }
        },
        methods:{
            getPage(obj){
                this.current_page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
            changeStatus(status){
                this.$emit("changeTab",status);
            }
        },
    }
</script>
